import axios from 'axios'
import { POLTRONA_GRATUITA_DISPONIVEL } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function poltronaGratuiraDisponivel (idEmpresa, idItinerario) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/itinerario/${idItinerario}/venda-gratuidade`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => dispatch({ type: POLTRONA_GRATUITA_DISPONIVEL, payload: response }))
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        // Offline: assume gratuidade permitida — o servidor valida no sync
        return dispatch({ type: POLTRONA_GRATUITA_DISPONIVEL, payload: { data: { usuarioVendeGratuidade: true } } });
      }
      throw erro;
    });
}
